import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getAuthToken = () => {
    const adminData = sessionStorage.getItem('adminkhadamat');
    if (adminData) {
        try {
            const parsed = JSON.parse(adminData);
            // البحث عن التوكن في أماكن مختلفة
            if (parsed.data?.token?.access_token) {
              const token = String(parsed.data.token.access_token);
              return token;
            }
            if (parsed.data?.access_token) return parsed.data.access_token;
            if (parsed.data?.token) return parsed.data.token;
            if (parsed.token) return parsed.token;
            if (parsed.result?.token) return parsed.result.token;
            if (parsed.user?.token) return parsed.user.token;
            return null;
        } catch {
            return null;
        }
    }
    return null;
};

// Fetch pharmacy settings
export const fetchPharmacySettings = createAsyncThunk(
    'adminPharmacySettings/fetchPharmacySettings',
    async (_, { rejectWithValue }) => {
        try {
            const token = getAuthToken();
            const response = await axios.get(`${BASE_URL}/admin/pharmacy/settings`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                },
            });

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في جلب إعدادات الصيدليات');
        }
    }
);

// Add/Update pharmacy settings
export const savePharmacySettings = createAsyncThunk(
    'adminPharmacySettings/savePharmacySettings',
    async (formData, { rejectWithValue }) => {
        try {
            const token = getAuthToken();
            const response = await axios.post(
                `${BASE_URL}/admin/pharmacy/settings`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept-Language': 'ar',
                        'lang': 'ar',
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في حفظ إعدادات الصيدليات');
        }
    }
);

const adminPharmacySettingsSlice = createSlice({
    name: 'adminPharmacySettings',
    initialState: {
        settings: null,
        loading: false,
        saving: false,
        error: null,
        success: null,
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        clearSuccess: (state) => {
            state.success = null;
        },
        clearSettings: (state) => {
            state.settings = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Settings
            .addCase(fetchPharmacySettings.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPharmacySettings.fulfilled, (state, action) => {
                state.loading = false;
                state.settings = action.payload.data;
            })
            .addCase(fetchPharmacySettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Save Settings
            .addCase(savePharmacySettings.pending, (state) => {
                state.saving = true;
                state.error = null;
            })
            .addCase(savePharmacySettings.fulfilled, (state, action) => {
                state.saving = false;
                state.success = action.payload.message || 'تم حفظ الإعدادات بنجاح';
                state.settings = action.payload.data;
            })
            .addCase(savePharmacySettings.rejected, (state, action) => {
                state.saving = false;
                state.error = action.payload;
            });
    },
});

export const { clearError, clearSuccess, clearSettings } = adminPharmacySettingsSlice.actions;
export default adminPharmacySettingsSlice.reducer;

